/**
 * Typed cache keys for the master-data feature.
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 * Each accessor's tuple shape matches the pre-migration inline keys
 * (`['contract-types']`, `['geo-locations']`, `['departments']`,
 * `['environments']`, `['cloud-providers']`, `['leadership-types']`,
 * `['person-types']`) so prefix-match invalidation continues to work.
 */
export const masterDataKeys = {
	contractTypes: {
		all: ['contract-types'] as const,
		list: () => ['contract-types'] as const,
	},
	geoLocations: {
		all: ['geo-locations'] as const,
		list: () => ['geo-locations'] as const,
	},
	departments: {
		all: ['departments'] as const,
		list: () => ['departments'] as const,
	},
	environments: {
		all: ['environments'] as const,
		list: () => ['environments'] as const,
	},
	cloudProviders: {
		all: ['cloud-providers'] as const,
		list: () => ['cloud-providers'] as const,
	},
	leadershipTypes: {
		all: ['leadership-types'] as const,
		list: () => ['leadership-types'] as const,
	},
	personTypes: {
		all: ['person-types'] as const,
		list: () => ['person-types'] as const,
	},
}
